import React from 'react'
import { ResourceSelector } from '@morningtrain/react-fields'

export default function EmployeeField(){
  return (
    <ResourceSelector
      name='contact_person_user_id'
      optionsKey='name'
      label='Kontaktperson'
      resourceName='users.users'
      operationName='select'
    >
    </ResourceSelector>
  )
}